import { render, staticRenderFns } from "./DateBlock.vue?vue&type=template&id=2766870c"
import script from "./DateBlock.vue?vue&type=script&lang=js"
export * from "./DateBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports